const KEY = "deviceLabels";

export function loadLabels() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

export function persistLabels(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function deviceKey(d) {
  return d && d.mac ? d.mac.toLowerCase() : d?.ip;
}

export function customLabel(d, labels) {
  if (!d || !labels) return null;
  return labels[deviceKey(d)] || null;
}
